var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.posts.length)?_c('section',{staticClass:"article-list"},_vm._l((_vm.posts),function(post,postIndex){return _c('PostCard',{key:`post-card-${postIndex}`,attrs:{"title":post.title,"slug":post.slug,"date":post.date,"thumbnail":post.thumbnail,"categories":post.categories,"min-read":post.minRead}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }